<template>
  <div>
    <div id="printTable">
      <div class="top">
        <div class="left">
          <p style="font-size:24px">{{ customerName }}</p>
          <div style="height: 15px"></div>
          <p>信息类运维工单</p>
        </div>
        <div class="right">
          <p>工单编号</p>
          <p>{{ obj.workNo }}</p>
          <h4 style="color: red">{{obj.typeName}}</h4>
        </div>
      </div>
      <table border="1" frame="cols" width="800">
        <tr>
          <td>
            <span style="color: #8394b1"> 报修人: </span>
            <span style="color: black">{{ obj.repairBy }}-{{ obj.repairPhone }}</span>
          </td>
          <td width="260px" ><span style="color: #8394b1">报修时间:</span>
            <span style="color: black">{{ obj.repairTime }}</span></td>
          <td rowspan="4">
            <img
                v-show="this.obj.equipmentImg ? true : false"
                :src="this.obj.equipmentImg"
                alt=""
            />
            <img
                v-show="this.obj.equipmentImg ? false : true"
                src="../../../assets/Logo4.png"
                alt=""
            />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span  style="color: #8394b1">所在位置: </span>
            <span style="color: black">{{ obj.deskName }} -
              {{ obj.facilitySite }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span  style="color: #8394b1">工单类型:</span>
            <span style="color: black">{{ obj.typeName }}-{{
                obj.facilityName
              }}-{{ obj.facilityType }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <span  style="color: #8394b1">故障描述:</span>
            <span style="color: black">{{ repairSource }}-{{
                obj.descr
              }}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span  style="color: #8394b1">处理人员: </span
            ><span style="color: black">{{ obj.maintainerName }}-{{ obj.maintenancePhone }}</span>
          </td>
          <td colspan="2">
            <span  style="color: #8394b1">完成时间:</span>
            <span style="color: black">{{obj.finishTime}}</span>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <span style="color: #8394b1"> 处理过程: </span
            ><span style="color: black">{{ obj2.maintainerContent }}</span>
          </td>
        </tr>
        <tr>
          <td><span style="color: #8394b1">维修类型:</span>
            <span style="color: black"> &#9744;换修类 &#9744;新增类 &#9744;服务类</span></td>
          <td width="50px" colspan="2"><span style="color: #8394b1">产生费用:<span style="color: black">￥{{obj.expensesIncurred}}</span></span></td>
        </tr>
        <tr>
          <td><span style="color: #8394b1">报修科室签字:</span></td>
          <td colspan="2"><span style="color: #8394b1">信息科签字:</span></td>
        </tr>
      </table>
    </div>
    <el-button type="primary" @click="bindPrint">打印</el-button>
  </div>
</template>

<script>
import printJS from "print-js";
export default {
  props: {
    workId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      finishimg:"",
      mainContext:"",
      obj: {},
      customerName: "",
      repairSource: "", //报修来源
      obj2: {}, //维修记录
    };
  },
  mounted() {
    if (this.workId) {
      this.getInfo(this.workId);
    }
    this.getCustomerInfo();
  },
  methods: {
    bindPrint() {
      // printJS({
      //   printable: "printTable",
      //   type: "html",
      //   header: null,
      //   targetStyles: ["*"],
      //   style: "@page {margin:0 10mm}",
      //   onError:(e,d)=>{
      //     console.log(e,d);
      // }
      // });
      this.printHtml("printTable")
    },

    printHtml(id_str){
      var el = document.getElementById(id_str);
      var iframe = document.createElement('iframe');
      var doc = null;
      iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
      document.body.appendChild(iframe);
      doc = iframe.contentWindow.document;
// 引入打印的专有css样式，www.111cn.net根据实际修改
      doc.write('<style>html {font-family: SimSun;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;}body {margin: 10px;}#printTable {width: 700px;margin: 20px 0;}img {height: 140px;padding: 5px;}.top {font-size: 18px;width: 800px;overflow: hidden;}.left {width: 350px;float: left;}.right {width: 300px;float: right;text-align: right;}table {border-collapse: collapse;border-spacing: 0;font-size: 18px;}td, th {padding: 0;padding-left: 5px;}td{height: 35px;}.pure-table {border-collapse: collapse;border-spacing: 0;empty-cells: show;border: 1px solid #cbcbcb;}.pure-table caption {color: #000;font: italic 85%/1 arial, sans-serif;padding: 1em 0;text-align: center;}.pure-table td, .pure-table th {border-left: 1px solid #cbcbcb;border-width: 0 0 0 1px;font-size: inherit;margin: 0;overflow: visible;padding: 0.5em 1em;}.pure-table thead {background-color: #e0e0e0;color: #000;text-align: left;vertical-align: bottom;}.pure-table td {background-color: transparent;}.pure-table-bordered td {border-bottom: 1px solid #cbcbcb;}.pure-table-bordered tbody > tr:last-child > td {border-bottom-width: 0;}</style>');
      doc.write('<p>' + el.innerHTML + '</p>');
      doc.close();
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);

    },
    async getInfo(item) {
      let id = item;
      try {
        let res = await $utils.api.load(`/maintainer/maintainer/workOrder/${id}`, {}, "GET");
        if (res.code === 200) {
          this.obj = res.data;

          if (res.data.repairSource == 1 || res.data.repairSource == 5) {
            this.repairSource = "医院提交";
          } else if (res.data.repairSource == 2) {
            this.repairSource = "维修员提交";
          } else {
            this.repairSource = "后台提交";
          }

          let arr = res.data.sysWorkTracks;
          let image =[]
          if(arr&&arr.length>0){
            for(let i = 0; i < arr.length; i++) {
              if (arr[i].workState == "3"){
                if (arr[i].imgUrl && arr[i].imgUrl.indexOf(",") != -1){
                  image = arr[i].imgUrl.split(",")
                  this.finishimg = image[0]
                }else {
                  this.finishimg = arr[i].imgUrl
                }
              }
            }
          }

          this.obj2 = arr[arr.length - 1];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCustomerInfo() {
      //检测登录状态
      let MaintainerToken = global.$utils.data.get("","token");

      if (!MaintainerToken ){
        if (window.localStorage.getItem('token')=='{"data":""}'){
          return
        }

      }
      // 加载详情数据
      let res = await $utils.api.load(
          `/maintainer/maiUser/getCustomerInfo`,
          {},
          "GET"
      );
      if (res && res.data) {
        this.customerName = res.data.customerName;
      }
    },
  },
};
</script>

<style scoped>
html {
  font-family: SimSun;

  -ms-text-size-adjust: 100%;

  -webkit-text-size-adjust: 100%;
}

body {
  margin: 10px;
}

#printTable {
  width: 700px;
  margin: 20px 0;
}
img {
  height: 140px;
  padding: 5px;
}
.top {
  font-size: 18px;
  width: 800px;
  overflow: hidden;
}
.left {
  width: 350px;
  float: left;
}
.right {
  width: 300px;
  float: right;
  text-align: right;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 18px;
}

td,
th {
  padding: 0;
  padding-left: 5px;
}
td{
  height: 35px;
}

.pure-table {
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
  border: 1px solid #cbcbcb;
}

.pure-table caption {
  color: #000;
  font: italic 85%/1 arial, sans-serif;
  padding: 1em 0;
  text-align: center;
}

.pure-table td,
.pure-table th {
  border-left: 1px solid #cbcbcb;
  border-width: 0 0 0 1px;
  font-size: inherit;
  margin: 0;
  overflow: visible;
  padding: 0.5em 1em;
}

.pure-table thead {
  background-color: #e0e0e0;
  color: #000;
  text-align: left;
  vertical-align: bottom;
}

.pure-table td {
  background-color: transparent;
}

.pure-table-bordered td {
  border-bottom: 1px solid #cbcbcb;
}

.pure-table-bordered tbody > tr:last-child > td {
  border-bottom-width: 0;
}
</style>